export default __webpack_public_path__ + "static/media/i1.0b07c20c.jpg";